import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
const _excluded = ["schema", "table", "id", "loadOptions", "loadOptionsWithFuzzy", "value", "placeholder", "noOptionsPlaceholder", "customGetList", "onClickButtonList", "loadedValues", "input", "idFieldTable", "valueObjectNeeded", "isValueObject"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, Fragment, useCallback, useState, useRef } from 'react';
import { Button, Select, createUseStyles, Tooltip } from '@Sage/hoi-poi-ui';
import { getList, getValue } from "../../../../lib/services/valueLists";
import { useWeb5Context } from "../../../../lib/Web5Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'List');
const CACHE = {};
const formatList = data => data.map(item => _objectSpread(_objectSpread({}, item), {}, {
  label: item.description,
  value: item.id
}));
function List(_ref) {
  var _schema$context, _schema$context$field, _schema$context$field2;
  let {
      schema,
      table,
      id,
      loadOptions,
      loadOptionsWithFuzzy,
      value,
      placeholder,
      noOptionsPlaceholder,
      customGetList,
      onClickButtonList,
      loadedValues,
      input,
      idFieldTable,
      valueObjectNeeded,
      isValueObject
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  // id could be the id of the field, if comes from an schema
  // idFieldTable is the name of the field where the table comes from
  const {
    t,
    language,
    platform,
    implementation
  } = useWeb5Context();
  const classes = useStyles();
  const [valueObject, setValueObject] = useState();
  const listTable = table || (schema === null || schema === void 0 ? void 0 : (_schema$context = schema.context) === null || _schema$context === void 0 ? void 0 : (_schema$context$field = _schema$context.fields) === null || _schema$context$field === void 0 ? void 0 : (_schema$context$field2 = _schema$context$field[id]) === null || _schema$context$field2 === void 0 ? void 0 : _schema$context$field2.table);
  const valueFromBackend = useRef(value && valueObjectNeeded);
  const getValueObjects = useCallback(() => {
    getValue(valueObjectNeeded === null || valueObjectNeeded === void 0 ? void 0 : valueObjectNeeded.table, value, language).then(_ref2 => {
      let {
        data
      } = _ref2;
      setValueObject({
        value: data.id,
        label: data.description || data.name || data.model || data.strName || `${data === null || data === void 0 ? void 0 : data.firstName} ${data === null || data === void 0 ? void 0 : data.lastName}`
      });
    }).catch(err => console.error(err)).then(() => valueFromBackend.current = false);
  }, [language, value, valueObjectNeeded]);
  useEffect(() => {
    if (valueObjectNeeded && valueFromBackend.current) {
      getValueObjects();
    }
  }, [getValueObjects, valueObjectNeeded]);
  useEffect(() => {
    if (!value && valueObject) setValueObject(null);
    if (value && valueObject && value !== valueObject.value) setValueObject(null);
  }, [value, valueObject]);

  // This loadedValues is necessary in order to include a new option when main options have been
  // already loaded (E.g. when creating a new Value List From ExtraFields Crud)
  const finalPropOptions = props.options || [];
  let loadedOptions = (loadedValues === null || loadedValues === void 0 ? void 0 : loadedValues.length) > 0 ? [...loadedValues, ...finalPropOptions] : finalPropOptions;
  const innerLoadOptions = useCallback(() => {
    const pr = new Promise((resolve, reject) => {
      if (customGetList) {
        customGetList(listTable, idFieldTable).then(_ref3 => {
          let {
            data
          } = _ref3;
          resolve(formatList(data));
        }).catch(err => {
          console.error(err);
          resolve([]);
        });
      } else {
        var _CACHE$implementation;
        if (platform === '101' && CACHE[listTable]) return resolve(CACHE[listTable] || []);
        if (platform === '107' && (_CACHE$implementation = CACHE[implementation]) !== null && _CACHE$implementation !== void 0 && _CACHE$implementation[listTable]) return resolve(CACHE[implementation][listTable] || []);
        if (!listTable) return resolve([]);
        getList({
          list: listTable,
          language
        }).then(_ref4 => {
          let {
            data
          } = _ref4;
          const formattedList = formatList(data);
          if (platform === '101') CACHE[listTable] = formattedList;
          if (platform === '107') {
            if (!CACHE[implementation]) CACHE[implementation] = {};
            CACHE[implementation][listTable] = formattedList;
          }
          resolve(formattedList);
        }).catch(err => {
          console.error(err);
          resolve([]);
        });
      }
    });
    return loadOptions ? loadOptions(pr) : pr;
  }, [loadOptions, customGetList, listTable, idFieldTable, platform, implementation, language]);
  const onClick = () => {
    onClickButtonList && onClickButtonList(value);
  };
  const finalValue = value !== undefined && value !== null ? value : undefined;
  const content = !(value !== null && value !== void 0 && value.isEditable) ? t('cfm_label_not_editable') : null;
  const loadOptionsWithTable = listTable ? innerLoadOptions : loadOptions;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Select, _extends({
    id: id,
    labelMode: "horizontal",
    value: valueObject || finalValue,
    isFullWidth: true,
    placeholder: placeholder || t('label_selectone'),
    isValueObject: valueObjectNeeded ? !!valueObject : isValueObject
  }, props, {
    options: loadedOptions,
    loadOptions: loadOptionsWithFuzzy || loadOptionsWithTable,
    noOptionsPlaceholder: noOptionsPlaceholder ? t(noOptionsPlaceholder) : t('label_no_options')
  })), onClickButtonList && /*#__PURE__*/React.createElement("div", {
    className: classes.button
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: content
  }, /*#__PURE__*/React.createElement(Button, {
    isDisabled: !(value !== null && value !== void 0 && value.isEditable),
    size: "small",
    type: "secondary",
    onClick: onClick
  }, t('cfm_label_update_table')))));
}
export default List;